// services/aboutYou.js — the About you page (founder, 2026-09-28): every fact
// the product keeps about the person, and the one way to change one. The
// facts, their order and every rule about them live on the server (Node
// Backend services/profile); each write answers with the page as it now
// stands, so the screen redraws from the server's word.
import { auth } from '../components/FirebaseConfig';
import { API_BASE } from '../apiSession';

const call = async (path, { method = 'GET', body } = {}) => {
  const token = await auth.currentUser?.getIdToken();
  if (!token) throw new Error('Sign in to see your details.');
  const res = await fetch(`${API_BASE}/api/profile/facts${path}`, {
    method,
    headers: { Authorization: `Bearer ${token}`, ...(body ? { 'Content-Type': 'application/json' } : {}) },
    body: body ? JSON.stringify(body) : undefined,
  });
  const json = await res.json().catch(() => null);
  // The month's AI used up (429) carries its words in `message`; `error` is
  // then a code, not something to show.
  if (!res.ok || !json?.ok) throw new Error(json?.message || json?.error || 'Could not reach your details. Try again.');
  return json;
};

/** { sections: [{ id, title, optional, facts }], progress: {done, total}, autoApply: {ready, needed}, hasResume } */
export const fetchFacts = () => call('');

/** Saves one fact; the page as it now stands. */
export const saveFact = (key, value) => call(`/${encodeURIComponent(key)}`, { method: 'PUT', body: { value } });

/** "Looks right" on what the page suggested for these keys; the page as it now stands. */
export const confirmFacts = (keys) => call('/confirm', { method: 'POST', body: { keys } });

/**
 * The first-run steps (Get started): { steps: [{ id, label, done, count }],
 * current, complete }. Resume → About you → Questions → Apply.
 */
export const fetchSteps = () => call('/steps');
